import { isPlainObject } from '@/utils/inspect';

export default {
  data: () => ({
    modalPropsWhitelist: null,
  }),

  methods: {
    /**
     * @param {Object} propsWhitelist
     * @returns {void}
     */
    setPropsWhitelist(propsWhitelist) {
      if (!isPlainObject(propsWhitelist)) return;
      this.modalPropsWhitelist = propsWhitelist;
    },

    /**
     * @param {Object} context
     * @returns {void}
     */
    modalBeforeOpen({ params }) {
      this.setupModalValues(params, this.modalPropsWhitelist);
    },

    /**
     * @param {Object} params
     * @param {Object} propsWhitelist
     * @returns {void}
     */
    setupModalValues(params, propsWhitelist) {
      if (!isPlainObject(params) || !isPlainObject(propsWhitelist)) return;
      const paramKeys = Object.keys(params);
      Object.keys(propsWhitelist).forEach((prop) => {
        if (paramKeys.includes(prop)) {
          this[prop] = params[prop];
        }
      });
    },
  },
};
